const AVATAR_COLORS = [
  "#F97316", "#3B82F6", "#10B981", "#8B5CF6",
  "#EF4444", "#F59E0B", "#6366F1", "#14B8A6",
];

/** Returns up to 2 uppercase initials from a display name. */
export const getInitials = (name = "") =>
  name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2) || "?";

/** Deterministically picks one of 8 avatar background colours based on name. */
export const getAvatarColor = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i++)
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

/** Picks a colour by index (for ordered lists where a consistent sequence looks good). */
export const getAvatarColorByIndex = (idx) =>
  AVATAR_COLORS[idx % AVATAR_COLORS.length];
